
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface UnreadBadgeProps {
  count: number;
  size?: 'sm' | 'md';
  className?: string;
  isActive?: boolean;
}

export const UnreadBadge: React.FC<UnreadBadgeProps> = ({ 
  count, 
  size = 'sm', 
  className,
  isActive = false
}) => {
  // Não renderizar nada se count for 0 ou menor
  if (!count || count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count.toString();

  return (
    <Badge
      variant="destructive"
      className={cn(
        "absolute -top-1 -right-1 flex items-center justify-center font-medium border-0 z-10",
        isActive ? "bg-white text-luxury-pinkBright" : "bg-luxury-red text-white",
        size === 'sm' ? "h-4 w-4 text-xs min-w-4 px-1" : "h-5 w-5 text-xs min-w-5 px-1.5",
        className
      )}
    >
      {displayCount}
    </Badge>
  );
};
